import {Swipejobs} from './Swipejobs';
import CustomerDesktopBase from '../CustomerDesktopBase';

export class CustomerDesktopSwipejobs extends Swipejobs {

    /**
     * Changes for Customer desktop Swipejobs
     * https://swipejobs.atlassian.net/wiki/spaces/PROD/pages/474185904/Customer+Desktop
     */

    constructor() {
        super();
        this.setSwipejobsCustomerColors();
    };

    private setSwipejobsCustomerColors (): void {
        this.colors.general.primaryColor = this.colorPalette.blueDark;
        this.colors.general.secondaryColor = this.colorPalette.grayDark;
        this.colors.general.tertiaryColor = this.colorPalette.blue;
        this.colors.general.blueDarkColor = this.colorPalette.blueDeep;

        this.colors.hover.primaryHoverColor = this.colorPalette.blueDeep;

        this.colors.text.passedTextColor = this.colorPalette.green;
        this.colors.text.successTextMessage = this.colorPalette.greenActive;
        this.colors.text.errorTextMessage = this.colorPalette.red;

        this.setDeprecatedSwipejobsCustomerColors();
    };

    private setDeprecatedSwipejobsCustomerColors (): void {

        /** @deprecated since version 0.2.*, use hover.primaryHoverColor */
        this.colors.general.primaryHoverColor = this.colorPalette.blueDeep;
        /** @deprecated since version 0.2.*, use hover.secondaryHoverColor */
        this.colors.general.secondaryHoverColor = this.colorPalette.grayDarker;

        /** @deprecated since version 0.2.*, use text.errorTextMessage */
        this.colors.general.errorTextMessage = this.colorPalette.red;
        /** @deprecated since version 0.2.*, use text.successTextMessage */
        this.colors.general.successTextMessage = this.colorPalette.greenActive;
    };
}

const customerDesktopSwipejobsTheme = CustomerDesktopBase.setShareStyles(new CustomerDesktopSwipejobs());
export default customerDesktopSwipejobsTheme;


// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/Swipejobs/customer-desktop.ts